export class Discipline {
	public constructor(
		public readonly identity: string,
		public readonly name: string,
		public readonly virtualPath: string,
		public readonly synonym?: string,
		public readonly parentIdentity?: string,
		public readonly icon?: string
	) {}
}
